<template>
  <v-select
    hide-details="auto"
    :items="status"
    v-model="filterDatas.expenseFor"
    item-text="name"
    item-value="id"
    label="Expense Form"
    outlined
    clearable
    dense
    @change="emitInput(filterDatas.expenseFor)"
  ></v-select>
</template>
<script>
import { mapState } from 'vuex';

export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    status: [
      {
        id: 'warehouse',
        name: 'Warehouse',
      },
      {
        id: 'shop',
        name: 'Shop',
      },
    ],
    selectStatus: null,
  }),
  computed: {
    ...mapState(['filterDatas']),
  },
  methods: {
    emitInput(data) {
      this.$store.commit('UPDATE_EXPENSE_FOR_FILTER', data);

      this.$emit('input', this.filterDatas.expenseFor);
    },
  },
  watch: {
    clear: {
      handler(val) {
        this.selectStatus = null;
      },
      deep: true,
    },
  },
  created() {
    this.$emit('input', this.filterDatas.expenseFor);
  },
};
</script>
